import { useRef } from 'react';
import PropTypes from 'prop-types';
import PlusOutlined from '@ant-design/icons/PlusOutlined';

import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import FormLine from 'src/components/ui/FormLine';
import IconButton from 'src/components/ui/IconButton';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';

const FieldRepeater = (props) => {
	const {
		label,
		error,
		deletable,
		helperText,
		lines = [],
		moreText = 'Добавить',
		onAdd,
		onDelete = () => {},
	} = props;

	const addRef = useRef();

	const hasHead = label || helperText || error;

	return (
		<Stack spacing={1}>
			<Stack spacing={1} alignItems="stretch">
				{hasHead && (
					<Stack spacing={1} alignItems="stretch">
						{label && <InputLabel>{label}</InputLabel>}
						{helperText && (
							<FormHelperText>{helperText}</FormHelperText>
						)}
						{error && (
							<FormHelperText error>{error}</FormHelperText>
						)}
					</Stack>
				)}
				{lines.map((line, i) => {
					return (
						<Stack key={line.id || i} spacing={1} direction="row">
							<Box width="100%">
								<FormLine {...line.props} />
							</Box>
							{deletable && (
								<IconButton
									onClick={() => {
										onDelete(i);
										addRef.current?.focus();
									}}
								>
									<DeleteOutlined />
								</IconButton>
							)}
						</Stack>
					);
				})}
			</Stack>
			<Box>
				<Button
					size="small"
					variant="text"
					disableRipple
					startIcon={<PlusOutlined />}
					onClick={onAdd}
					ref={addRef}
				>
					{moreText}
				</Button>
			</Box>
		</Stack>
	);
};

FieldRepeater.propTypes = {
	label: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	helperText: PropTypes.string,
	moreText: PropTypes.string,
	deletable: PropTypes.bool,
	onAdd: PropTypes.func,
	onDelete: PropTypes.func,
	lines: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			props: PropTypes.shape(FormLine.propTypes),
		}),
	),
};

export default FieldRepeater;
